import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Badge, Card, Table } from 'react-bootstrap';
import { toast } from 'react-toastify';
import superAdminApiClient from '../../../api/superAdminApiClient';

const FrontendPagesListing = () => {
    const [pages, setPages] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchPages = async () => {
            try {
                const response = await superAdminApiClient.get('/superadmin/web-pages/frontend-pages');
                setPages(response.data.data || []);
            } catch (error) {
                toast.error('Failed to fetch header pages');
            } finally {
                setLoading(false);
            }
        };

        fetchPages();
    }, []);

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-12">
                    <div className="page-title-box d-sm-flex align-items-center justify-content-between m-0 mb-3">
                        <h4 className="mb-sm-0 font-weight-bold text-dark">Header Web Pages</h4>
                    </div>
                </div>
            </div>

            <Card className="border-0 shadow-sm" style={{ borderRadius: '12px' }}>
                <Card.Body className="p-0">
                    <div className="table-responsive">
                        <Table className="table align-middle table-nowrap mb-0 table-hover">
                            <thead className="table-light text-muted">
                                <tr>
                                    <th className="py-3 px-4">Page</th>
                                    <th>Slug</th>
                                    <th>Sections</th>
                                    <th>Status</th>
                                    <th>Last Updated</th>
                                    <th className="text-center px-4" style={{ width: '120px' }}>Actions</th>
                                </tr>
                            </thead>
                            <tbody className="text-dark">
                                {loading ? (
                                    <tr>
                                        <td colSpan="6" className="text-center py-5">
                                            <div className="spinner-border text-primary" role="status">
                                                <span className="visually-hidden">Loading...</span>
                                            </div>
                                        </td>
                                    </tr>
                                ) : pages.length === 0 ? (
                                    <tr>
                                        <td colSpan="6" className="text-center py-5 text-muted">
                                            <i className="ri-layout-3-line fs-36 d-block mb-2 text-secondary"></i>
                                            No header pages found. Run the frontend page seeder once.
                                        </td>
                                    </tr>
                                ) : pages.map((page) => (
                                    <tr key={page.id}>
                                        <td className="font-weight-semibold text-dark px-4">
                                            <div>{page.title}</div>
                                            <code className="text-primary fs-12">{page.page_key}</code>
                                        </td>
                                        <td>{page.slug}</td>
                                        <td>
                                            <Badge bg="light" className="text-primary border border-primary-subtle">
                                                {(page.Sections || []).length} Section{(page.Sections || []).length === 1 ? '' : 's'}
                                            </Badge>
                                        </td>
                                        <td>
                                            <Badge bg={page.status === 'active' ? 'success' : 'secondary'}>
                                                {page.status}
                                            </Badge>
                                        </td>
                                        <td className="text-secondary fs-13">
                                            {new Date(page.updated_at || page.updatedAt).toLocaleDateString('en-US', {
                                                year: 'numeric',
                                                month: 'short',
                                                day: 'numeric',
                                                hour: '2-digit',
                                                minute: '2-digit'
                                            })}
                                        </td>
                                        <td className="px-4">
                                            <div className="d-flex gap-2 justify-content-center">
                                                <Link
                                                    to={`/superadmin/web-pages/header-pages/${page.page_key}`}
                                                    className="btn btn-sm btn-light border"
                                                    style={{ padding: '0.35rem 0.55rem' }}
                                                >
                                                    <i className="ri-pencil-fill text-muted fs-14"></i>
                                                </Link>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </div>
                </Card.Body>
            </Card>
        </div>
    );
};

export default FrontendPagesListing;
